import { AttributeOption } from '@deltager/organizers/admin/modules/events/create-event/model/attribute-option.model';
import { AttributeRelation } from '@deltager/organizers/admin/modules/events/create-event/model/attribute-relation.model';
import { AttributeType } from './attribute-type.enum';
import { QuestionType } from './question-type.enum';
import { EventAttributeDropdownType } from '../../../../shared/models/attribute-dropdown-type.enum';
import { PrioritizeListItem } from './prioritizelistItem.model';
import { UploadProperties } from '@deltager/organizers/admin/modules/events/create-event/model/attribute-upload.model';
import { BuiltInAttributeType } from '@deltager/organizers/admin/shared/models/built-in-attribute-type.enum';

export class GeneralAttribute implements PrioritizeListItem {
  id?: number;
  name: string;
  placeholder: string;
  active: boolean;
  type?: QuestionType;
  systemType?: BuiltInAttributeType;
  dropdownType: EventAttributeDropdownType;
  isShowAttrType: boolean;
  priority: number;
  mandatory: boolean;
  showOnReceipt: boolean;
  disabled?: boolean;
  askOncePerOrder: boolean;
  showOnParticipantsList: boolean;
  showOnInstructorsList: boolean;
  copyAnswerToAllParticipants: boolean;
  changeByAdminOnly: boolean;
  includeInInvitations: boolean;
  renderAsYearPicker?: boolean;
  options: AttributeOption[];
  typeOfAttr: AttributeType;
  uiId: number;
  vat: number;
  checkboxPrice?: number;
  checkboxNonRefundable: boolean;
  productId?: number;
  isBuiltinAttr: boolean;
  dependencies: AttributeRelation[];
  description: string;
  multiline: boolean;
  onlyNumbers: boolean;
  hasAttributeDependencies: boolean;
  isParticipantEditingEnabled: boolean;

  wizardId?: boolean;
  affiliateId?: boolean;
  belongsTo?: boolean;
  clearField?: boolean;
  locked?: boolean;
  showInList?: boolean;
  width?: number;
  uploadProperties?: UploadProperties;
  isLimitNumberOfCharacters: boolean;
  maxNumberOfCharacters: number;
  customValidationId: number;
  addToUserProfile: boolean;
  maxAmountOfRegistrations: number;
  registered: number;

  isMembershipNumber: boolean;

  get hasDependencies(): boolean {
    return this.dependencies && this.dependencies.length > 0 && this.dependencies.some(d => d !== undefined);
  }

  get isCheckbox(): boolean {
    return !this.isBuiltinAttr && this.type === QuestionType.CHECKBOX;
  }

  get isDropdown(): boolean {
    return !this.isBuiltinAttr && this.type == QuestionType.DROPDOWN;
  }

  get isFileUplaod(): boolean {
    return !this.isBuiltinAttr && this.type === QuestionType.FILE_UPLOAD;
  }
}
